function convertCelsiusToFahrenheit(num) {
  let eq =
    "Converting " +
    num +
    "° celsius to fahrenheit: \n" +
    "((" +
    num +
    " * 9) / 5) + 32 = ";
  let rep = (num * 9) / 5 + 32 ;
  return eq + rep.toFixed(2);
}

function convertCelsiusToKelvin(num) {
  let eq =
    "Converting " + num + "° celsius to kelvin: \n" + num + " 273.15 = ";
  let rep = num + 273.15;
  return eq + rep.toFixed(3);
}

function convertCelsiusToRankine(num) {
  let eq =
    "Converting " +
    num +
    "° celsius to rankine: \n" +
    "((" +
    num +
    " 273.15) * 9) / 5 = ";
  let rep = ((num + 273.15) * 9) / 5 ;
  return eq + rep.toFixed(3);
}

function convertCelsiusToDelisle(num) {
  let eq =
    "Converting " +
    num +
    "° celsius to delisle: \n" +
    "((100 - " +
    num +
    ") * 3) / 2 = ";
  let rep = ((100 - num) * 3) / 2 ;
  return eq + rep.toFixed(2);
}

function convertCelsiusToNewton(num) {
  let eq =
    "Converting " +
    num +
    "° celsius to newton: \n" +
    "+(" +
    num +
    " * 100) / 33 = ";
  let rep = (num * 100) / 33 ;
  return eq + rep.toFixed(2);
}

function convertCelsiusToRéaumur(num) {
  let eq =
    "Converting " +
    num +
    "° celsius to réaumur: \n" +
    "(" +
    num +
    " * 4) / 5 = ";
  let rep = (num * 4) / 5 ;
  return eq + rep.toFixed(2);
}

function convertCelsiusToRømer(num) {
  let eq =
    "Converting " +
    num +
    "° celsius to rømer: \n" +
    "((" +
    num +
    " * 21) / 40) + 7.5 = ";
  let rep = (num * 21) / 40 + 7.5 ;
  return eq + rep.toFixed(3);
}

export {
  convertCelsiusToFahrenheit,
  convertCelsiusToRømer,
  convertCelsiusToRéaumur,
  convertCelsiusToNewton,
  convertCelsiusToDelisle,
  convertCelsiusToRankine,
  convertCelsiusToKelvin
};
